import React from "react";

import Event from "./event/Event";

const Timeline = ({ data }) => {
    return (
        <div className="timeline">
            {data.map((details, idx) => (
                <Event
                    key={details.id}
                    {...details}
                    lastEvent={data.length === idx + 1}
                />
            ))}
        </div>
    );
};

export default Timeline;
